import React from 'react';
import Dict from 'dict-lib';

import stylesLexemePage from './../../../../_css/dictionary/lexemePage.module.css';

export class LexemeDictionaryType extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const isTreeModel = this.props.page.lexeme_properties.is_tree_model;
        const isExternalDict = this.props.page.isExternalDict;
        var text = (this.props.page.dictionary_properties.language_code).toLowerCase();

        if(this.props.isMobile) {
            text = '';
        } else if (isTreeModel) {
            text = this.props.page.dictionary_properties.name
        } else if (isExternalDict) {
            text += ' - ' + Dict.t('FROM_DICTIONARY') + ' ' + this.props.page.externalDictName;
        }

        return <div
            className={stylesLexemePage['lexemeDictionaryType']}>{text}</div>;
    }
}
